import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_ADDON_ALIGN_CLASS_MAP,
  INPUT_GROUP_ADDON_CLASS,
  INPUT_GROUP_ADDON_DEFAULTS,
  TInputGroupAddonProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";

export const InputGroupAddon: FC<TInputGroupAddonProps> = (
  {
    className,
    align = INPUT_GROUP_ADDON_DEFAULTS.align,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-align={align}
    data-component="InputGroupAddon"
    className={cn(
      INPUT_GROUP_ADDON_CLASS,
      INPUT_GROUP_ADDON_ALIGN_CLASS_MAP[align],
      className,
    )}
  >
    { children }
  </div>
);

InputGroupAddon.displayName = "InputGroupAddon";
